module.exports = __webpack_public_path__ + "static/media/main-banner-img.35627e5c.svg";